import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {DialogProps} from 'packages/common-types/base-types';

type Props = DialogProps & {
  onFinishTournament: () => void;
  loading: boolean;
};
const ConfirmFinishTournament = (props: Props) => {
  const {toggle, modalOpen, onFinishTournament, loading} = props;

  return (
    <Dialog open={modalOpen} onClose={toggle} aria-labelledby="">
      <DialogTitle id="">Estas a punto de terminar el torneo</DialogTitle>
      <DialogContent>
        {loading && <LinearProgress />}
        <DialogContentText>
          ¿Estás completamente seguro de terminar el torneo?.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={toggle} color="default">
          Cancelar
        </Button>
        <Button onClick={onFinishTournament} color="primary">
          Terminar torneo
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmFinishTournament;
